'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHeader, styles } from '../../product-landing/ProductLanding';

interface ToolItem {
  label: string;
  description: string;
}

export default function ToolsListSection() {
  const { t } = useTranslation('start');
  const raw = t('mcp.tools.items', { returnObjects: true });
  const items: ToolItem[] = Array.isArray(raw)
    ? (raw as ToolItem[]).filter((item) => item && typeof item.label === 'string' && typeof item.description === 'string')
    : [];
  return (
    <section className={`${styles.section} ${styles.band}`}>
      <SectionHeader title={t('mcp.tools.title')} intro={t('mcp.tools.intro')} />
      <div className={styles.cardGrid}>
        {items.map((tool) => (
          <article key={tool.label} className={styles.card}>
            <h3>{tool.label}</h3>
            <p>{tool.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
